import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/API/api.service';

@Component({
  selector: 'app-order-apps',
  templateUrl: './order-apps.component.html',
  styleUrl: './order-apps.component.scss'
})
export class OrderAppsComponent implements OnInit {

  orderApps: any;
  isLoading: boolean = false;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.loadOrderApps();
  }

  loadOrderApps(){
    this.isLoading = true;
    this.apiService.orderApss().subscribe({
      next: response => {
        this.orderApps = response.data;
        this.isLoading = false;
      }, 
      error: (error: any) => {
        console.log(error);
      }
    });
  }

}
